import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Input } from '@angular/core';
import {Observable } from 'rxjs'; // /observable
import { FormGroup, FormControl } from '@angular/forms';

// Servicio
import { ClientesService } from '../../../services/Clientes.service';
import { RutasService } from '../../../services/rutas.service';
// Ngb
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { map } from 'rxjs/operators';


@Component({
  selector: 'app-busqueda-avanzada',
  templateUrl: './busqueda-avanzada.component.html',
  styleUrls: ['./busqueda-avanzada.component.css']
})
export class BusquedaAvanzadaComponent implements OnInit, AfterViewInit {
  @ViewChild('nombreInput') private elementRef: ElementRef;
  @Input() tipo: any;
  listaClientes: Observable<Array<any>>;
  listaRutas: Observable<Array<any>>;
  form: FormGroup;
  constructor(private clienteService: ClientesService,
              public activeModal: NgbActiveModal,
              private rutaService: RutasService) {
    // Cargar la lista de clientes

    // Inicializar formulario
    this.form = new FormGroup({
      'nombre': new FormControl(''),
      'cedula': new FormControl(''),
      'telefono': new FormControl(''),
      'ruta': new FormControl(''),
      'direccion': new FormControl('')
    });

    // Cargar todas las rutas
    this.listaRutas = this.rutaService.cargarTodasLasRutas().pipe(map(result => result.rutas));
  }

  ngOnInit() {
    this.listaClientes = this.clienteService.busquedaAvanzada(null, this.tipo);
  }

  ngAfterViewInit(): void {
    this.elementRef.nativeElement.focus();
  }

  buscar() {
    this.listaClientes = this.clienteService.busquedaAvanzada(this.form.value, this.tipo);
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/busqueda-avanzada/busqueda-avanzada.component.ts